import { Show } from '@bygghemmait/components';
import { useDidMount } from '@bygghemmait/hooks';
import { useState, type ReactNode } from 'react';

type DelayProps = {
  delay: number;
  children: ReactNode;
};
export const Delay = ({ delay, children }: DelayProps): JSX.Element => {
  const [isVisible, setVisible] = useState(false);

  useDidMount(() => {
    const timeout = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timeout);
  });

  return <Show when={isVisible}>{children}</Show>;
};
